var map = {
	"./about-us.svg": "tCfw",
	"./app.svg": "CGqL",
	"./blockchain.svg": "Fafa",
	"./contect.svg": "aLHV",
	"./game.svg": "ev1J",
	"./video-stream.svg": "YiGv",
	"./web-site.svg": "q3wo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 0